exports.host=process.env.VUE_APP_SITE_HOST_NAME;
exports.siteUrl=process.env.VUE_APP_SITEURL;
exports.baseUrl=process.env.VUE_APP_API_BASE_PREMIER;
exports.Domain=process.env.VUE_APP_SITE_DOMAIN;
exports.benefitBaseUrl=process.env.VUE_APP_API_BASE_BENEFIT;
